import { render, staticRenderFns } from "./DialogAttachment.vue?vue&type=template&id=23e73bdd&scoped=true&"
import script from "./DialogAttachment.vue?vue&type=script&lang=js&"
export * from "./DialogAttachment.vue?vue&type=script&lang=js&"
import style0 from "./DialogAttachment.vue?vue&type=style&index=0&id=23e73bdd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e73bdd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/joeldev/Developer/clientes/aduanas-pty/front-transit/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VCard,VIcon})
